import request from '@/utils/request'

export function getMarketSegmentApi(query) {
  return request({
    url: '/config-service/v1/statistic/market-seg-group/market-seg',
    method: 'get',
    params: query
  })
}
